export class AgentAssistLogin extends HTMLElement {
    private template: HTMLTemplateElement;

    constructor() {
        super();
        this.template = document.createElement('template');
        this.attachShadow({ mode: 'open' });
        this.template.innerHTML = '<spinner-element></spinner-element>';
    }

    connectedCallback() {
        this.shadowRoot.appendChild(this.template.content.cloneNode(true));

        const params = new URLSearchParams(document.location.search);
        const agentAssistUrl = params.get('agent-assist-url');
        const pathHubs = window.location.pathname.split('/').filter(p => p.length);
        const path = pathHubs.length > 1 ? `/${pathHubs[0]}` : '';
        const redirect = window.location.origin + path + '/requestclose';
        window.location.href = `${agentAssistUrl}?redirect=${encodeURIComponent(redirect)}`;
    }
}

window.customElements.define('agent-assist-login-component', AgentAssistLogin);
